export default __webpack_public_path__ + "static/media/banner2.707799d5.png";